module.exports = __webpack_public_path__ + "media/application/images/icons/desktop-solid-8266adf145aee94d79470e7dc7c73a17.svg";